/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as DropdownButtonDefault } from './dropdown-button-default.story';
export { default as DropdownButtonWithAvatar } from './dropdown-button-with-avatar.story';
export { default as DropdownButtonWithStatusIndicator } from './dropdown-button-with-status-indicator.story';
export { default as DropdownButtonDisabled } from './dropdown-button-disabled.story';
export { default as DropdownButtonFloating } from './dropdown-button-floating.story';
export { default as DropdownButtonWithMenu } from './dropdown-button-with-menu.story';
export { default as DropdownButtonLoading } from './dropdown-button-loading.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import DropdownButtonDefaultSourceRaw from './dropdown-button-default.story?raw';
import DropdownButtonDisabledSourceRaw from './dropdown-button-disabled.story?raw';
import DropdownButtonFloatingSourceRaw from './dropdown-button-floating.story?raw';
import DropdownButtonLoadingSourceRaw from './dropdown-button-loading.story?raw';
import DropdownButtonWithAvatarSourceRaw from './dropdown-button-with-avatar.story?raw';
import DropdownButtonWithMenuSourceRaw from './dropdown-button-with-menu.story?raw';
import DropdownButtonWithStatusIndicatorSourceRaw from './dropdown-button-with-status-indicator.story?raw';

export const DropdownButtonDefaultSource = removeLicenseHeader(
  DropdownButtonDefaultSourceRaw,
);
export const DropdownButtonWithAvatarSource = removeLicenseHeader(
  DropdownButtonWithAvatarSourceRaw,
);
export const DropdownButtonWithStatusIndicatorSource = removeLicenseHeader(
  DropdownButtonWithStatusIndicatorSourceRaw,
);
export const DropdownButtonDisabledSource = removeLicenseHeader(
  DropdownButtonDisabledSourceRaw,
);
export const DropdownButtonFloatingSource = removeLicenseHeader(
  DropdownButtonFloatingSourceRaw,
);
export const DropdownButtonWithMenuSource = removeLicenseHeader(
  DropdownButtonWithMenuSourceRaw,
);
export const DropdownButtonLoadingSource = removeLicenseHeader(
  DropdownButtonLoadingSourceRaw,
);
